import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=1536432b"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports